import React from 'react';
import {
  colors,
  FormControl,
  FormControlLabel,
  RadioGroup,
  InputLabel,
  Theme,
} from '@mui/material';
import { Radio } from 'app/components/MuiCompat';
import { createStyles } from 'app/util/styles';
import { withStyles } from 'tss-react/mui';
import { Field } from 'redux-form';
import { required } from 'app/util/validators';
import { RootState } from 'app/store/types';
import { connect } from 'react-redux';
import { creditBoosterProgramSelector } from 'app/reducers/rates';

const styles = (theme: Theme) => createStyles({
  selected: {
    [theme.breakpoints.down('md')]: {
      background: theme.palette.secondary.main,
      '& span': {
        color: '#ffffff',
      },
    },
  },
  radioLabel: {
    marginTop: 5,
    marginRight: 0,
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      paddingTop: 2,
      paddingBottom: 2,
      borderBottom: `1px solid ${colors.grey[300]}`,
    },
  },
  radioWrapper: {
    marginTop: 15,
    '& label': {
      marginRight: 0,
      fontWeight: 400,
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        marginLeft: 0,
        '& span:last-child': {
          marginLeft: 10,
        },
      },
    },
    '& label.selected span': {
      [theme.breakpoints.down('md')]: {
        '& span': {
          color: '#ffffff',
        },
      },
    },
  },
});

const renderRadioGroup = (props) => {
  const { classes } = props;
  return (
    <FormControl fullWidth>
      <RadioGroup {...props.input}>
        {props.options.map((option, index) => {
          return (
            <React.Fragment key={index}>
              <FormControlLabel
                control   = {<Radio color='primary' />}
                label     = {option.title}
                value     = {option.value}
                className = {props.input.value === option.value ? `${classes.radioLabel} ${classes.selected}` : classes.radioLabel}
              />
            </React.Fragment>
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

type CreditBoosterLoanOptionsProps = any;

const CreditBoosterLoanOptionsComponent = withStyles(({ ...props }: CreditBoosterLoanOptionsProps) => {
  const { classes, creditBoosterPrograms } = props;
  return (
    <div className={classes.radioWrapper}>
      { props.label ? <InputLabel shrink>{ props.label }</InputLabel> : null }
      <Field
        classes   = {props.classes}
        component = {renderRadioGroup}
        name      = {props.name}
        onChange  = {props.onChange}
        options   = {creditBoosterPrograms}
        validate  = {[required]}
      />
    </div>
  );
}, styles);

const mapStateToProps = (state: RootState) => ({
  creditBoosterPrograms: creditBoosterProgramSelector(state),
});

export const CreditBoosterLoanOptions = connect(mapStateToProps)(CreditBoosterLoanOptionsComponent);
